import React from 'react';

export default () => (
    <div className="view-header">
        <header className="title text-white">
            <h1 className="h4 text-uppercase">FTP Credentials</h1>
            <p className="mb-0">List of ftp credentials</p>
        </header>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/ftp-credentials/view-header.js